
import { defineComponent } from 'vue';
import { ElRow, ElCol } from 'element-plus';

export default defineComponent({
  components: { ElRow, ElCol },
});
